import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { ProductionCenterFilters, ProductionCenterType } from '../types';

import { productionCenterQueryKeys } from './query-keys';

export async function getProductionCenters(
  params?: ParamsWithPagination<ProductionCenterFilters>
): Promise<PaginatedResponse<ProductionCenterType>> {
  return mediaManagerClient.get('api/v1/production_centers', {
    params: {
      production_center_type: params?.type,
      updated_by__in: params?.updatedByIn?.join(','),
      id__in: params?.idIn?.join(','),
      limit: params?.limit,
      offset: params?.offset,
      search: params?.search,
    },
  });
}

type QueryFnType = typeof getProductionCenters;

interface UseProductionCentersParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<ProductionCenterFilters>;
}

export function useProductionCenters({ config, params }: UseProductionCentersParams = {}) {
  return useQuery({
    ...config,
    queryKey: productionCenterQueryKeys.list(params),
    queryFn: () => getProductionCenters(params),
  });
}
